<template>
  <v-card>
    <BarTitleDialog
      title="Vincular Quarto"
      @close="$emit('close')"
    />
    <v-card-text>
      <v-row no-gutters>
        <v-col>
          <span class="text-body-2">
            Reserva #{{ reserve.id }} — {{ reserve.room_category ? reserve.room_category.description : '' }} —
            {{ formatDate(reserve.check_in) }} a {{ formatDate(reserve.check_out) }}
          </span>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col>
          <v-select
            v-model="selectedRoomId"
            :items="sortedRooms"
            item-value="id"
            :loading="loadingRooms"
            :error-messages="error"
            outlined
            label="Quarto"
            no-data-text="Nenhum quarto disponível para o período"
            @change="error = null"
          >
            <template v-slot:item="{ item }">
              <div
                class="d-flex align-center justify-space-between"
                style="width: 100%"
              >
                <span>{{ item.description }} — {{ item.category ? item.category.description : '' }}</span>
                <v-chip
                  v-if="isSameCategory(item)"
                  x-small
                  color="primary"
                  class="ml-2"
                >
                  Mesma categoria
                </v-chip>
              </div>
            </template>
            <template v-slot:selection="{ item }">
              {{ item.description }} — {{ item.category ? item.category.description : '' }}
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-row>
        <v-col class="text-right">
          <v-btn
            text
            x-large
            class="mr-4"
            @click="$emit('close')"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            x-large
            :loading="loadingAssign"
            :disabled="loadingAssign || !selectedRoomId"
            @click="confirm()"
          >
            Vincular
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    BarTitleDialog,
  },
  props: {
    reserve: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    rooms: [],
    selectedRoomId: null,
    loadingRooms: false,
    loadingAssign: false,
    error: null,
  }),
  computed: {
    sortedRooms() {
      return [...this.rooms].sort((a, b) => {
        const aSame = this.isSameCategory(a) ? 0 : 1
        const bSame = this.isSameCategory(b) ? 0 : 1
        if (aSame !== bSame) return aSame - bSame

        return (a.description || '').localeCompare(b.description || '', undefined, { numeric: true })
      })
    },
  },
  created() {
    this.loadRooms()
  },
  methods: {
    ...mapActions('reserve', ['availableRoomsForAssignment', 'assignRoom']),
    loadRooms() {
      this.loadingRooms = true
      this.availableRoomsForAssignment(this.reserve.id)
        .then(response => {
          this.rooms = response.data
        })
        .finally(() => {
          this.loadingRooms = false
        })
    },
    isSameCategory(room) {
      return Number(room.room_category_id) === Number(this.reserve.room_category_id)
    },
    confirm() {
      if (!this.selectedRoomId) return

      this.loadingAssign = true
      this.assignRoom({ reserve_id: this.reserve.id, room_id: this.selectedRoomId })
        .then(response => {
          this.$toast.success('Quarto vinculado com sucesso')
          this.$emit('assigned', response.data)
        })
        .catch(error => {
          this.error = error?.response?.data?.message || 'Erro ao vincular quarto'
        })
        .finally(() => {
          this.loadingAssign = false
        })
    },
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('T')[0].split('-')

      return `${day}/${month}/${year}`
    },
  },
}
</script>
